import React from 'react';
import classNames from 'classnames';
import classes from './item-title.scss';
const HeadingComponentDefault = params => /*#__PURE__*/React.createElement("div", params);
const ItemTitle = ({
  productName,
  productNameClass,
  modifiedProductName,
  modifiedProductNameClass,
  headingComponent: HeadingComponent = HeadingComponentDefault,
  headingClassName,
  isNewName,
  nameLabel
}) => {
  const className = classNames(productNameClass || classes.name, headingClassName);
  if (!modifiedProductName) {
    return /*#__PURE__*/React.createElement(HeadingComponent, {
      className: className,
      "data-text": "Name"
    }, productName, " ", nameLabel && /*#__PURE__*/React.createElement("span", {
      className: classes.label
    }, "(", nameLabel, ")"));
  }
  return /*#__PURE__*/React.createElement(HeadingComponent, {
    "data-text": "Name"
  }, /*#__PURE__*/React.createElement("span", {
    className: className
  }, modifiedProductName), isNewName && /*#__PURE__*/React.createElement("span", {
    className: modifiedProductNameClass || classes.nameOriginal
  }, "(", productName, ")"), nameLabel && /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, "(", nameLabel, ")"));
};
export default ItemTitle;